import { defineAsyncComponent } from 'vue'
import LoadingView from '@/src/router/views/_shared/LoadingView'
import TimeoutView from '@/src/router/views/_shared/TimeoutView'
import store from '@state/store'

const checkRole = (next, page, storePath) => {
  if (store.getters[`auth/${storePath}`][page]) {
    next()
  } else {
    next({
      path: '/404',
    })
  }
}

export const checkReportRole = (page, storePath) => {
  if (store.getters[`auth/${storePath}`][page]) {
    return true
  } else {
    return false
  }
}


export default [
  {
    path: '/',
    name: 'landing-page',
    component: () => lazyLoadView(import('@views/LandingPageView')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/docs/staff',
    name: 'staff-documentation',
    component: () => lazyLoadView(import('@views/StaffApiDocView')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/docs/common',
    name: 'common-documentation',
    component: () => lazyLoadView(import('@views/CommonApiDocView')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/docs/passenger',
    name: 'passenger-documentation',
    component: () => lazyLoadView(import('@views/PassengerApiDocView')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/callback',
    name: 'callback',
    component: () => lazyLoadView(import('@views/authentication/CallbackView')),
  },
  {
    path: '/bookings',
    name: 'bookings-index',
    component: () => lazyLoadView(import('@views/bookings/BookingsListView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        checkRole(next, 'booked_journey_page', 'primaryUserRole')
      },
    },
  },
  {
    path: '/bookings/new',
    name: 'booking-new',
    component: () => lazyLoadView(import('@views/bookings/BookingCreateView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        checkRole(next, 'new_journey_page', 'primaryUserRole')
      },
    },
  },
  {
    path: '/bookings/:ref/edit',
    name: 'booking-edit',
    component: () => lazyLoadView(import('@views/bookings/BookingEditView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        checkRole(next, 'new_journey_page', 'primaryUserRole')
      },
    },
  },
  {
    path: '/bookings/:ref/duplicate',
    name: 'booking-duplicate',
    component: () =>
      lazyLoadView(import('@views/bookings/BookingDuplicateView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        checkRole(next, 'new_journey_page', 'primaryUserRole')
      },
    },
  },
  {
    path: '/bookings/:ref',
    name: 'booking-show',
    component: () => lazyLoadView(import('@views/bookings/BookingShowView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        checkRole(next, 'booked_journey_page', 'primaryUserRole')
      },
    },
  },
  {
    path: '/unconfirmed',
    name: 'bookings-unconfirmed',
    component: () =>
      lazyLoadView(import('@views/bookings/BookingUnconfirmedView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        checkRole(next, 'unconfirmed_bookings_page', 'primaryUserRole')
      },
    },
  },
  {
    path: '/reports',
    name: 'reports-index',
    component: () => lazyLoadView(import('@views/reports/ReportsListView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        checkRole(next, 'reports_page', 'primaryUserRole')
      },
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard-index',
    component: () => lazyLoadView(import('@views/dashboard/DashboardPageView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        checkRole(next, 'dashboard_page', 'primaryUserRole')
      },
    },
  },
  {
    path: '/users',
    name: 'users-index',
    component: () => lazyLoadView(import('@views/users/UsersListView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        checkRole(next, 'staff_member_page', 'secondaryUserRole')
      },
    },
  },
  {
    path: '/users/new',
    name: 'user-new',
    component: () => lazyLoadView(import('@views/users/UserCreateView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        checkRole(next, 'create_user', 'secondaryUserRole')
      },
    },
  },
  {
    path: '/users/:ref',
    name: 'user-edit',
    component: () => lazyLoadView(import('@views/users/UserEditView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        checkRole(next, 'create_user', 'secondaryUserRole')
      },
    },
  },
  {
    path: '/access_control',
    name: 'access_control',
    component: () => lazyLoadView(import('@views/users/AccessControlView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        checkRole(next, 'access_control_page', 'secondaryUserRole')
      },
    },
  },
  {
    path: '/configurations',
    name: 'configurations',
    component: () => lazyLoadView(import('@views/users/ConfigurationsView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/currentUser'].access_to_configuration_page) {
          next()
        } else {
          next({
            path: '/404',
          })
        }
      },
    },
  },
  {
    path: '/stations',
    name: 'stations-index',
    component: () => lazyLoadView(import('@views/stations/StationsListView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        checkRole(next, 'train_station_page', 'secondaryUserRole')
      },
    },
  },
  {
    path: '/stations/:ref',
    name: 'station-edit',
    component: () => lazyLoadView(import('@views/stations/StationEditView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        checkRole(next, 'train_station_page', 'secondaryUserRole')
        if (store.getters['auth/roleName'] !== 'View Only') {
          next()
        } else {
          next({
            path: '/404',
          })
        }
      },
    },
  },
  {
    path: '/passengers',
    name: 'passengers-index',
    component: () =>
      lazyLoadView(import('@views/passengers/PassengerListView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        checkRole(next, 'passenger_page', 'secondaryUserRole')
      },
    },
  },
  {
    path: '/statistics',
    name: 'statistics-index',
    component: () => lazyLoadView(import('@views/statistics/StatisticsView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        checkRole(next, 'statistics_page', 'secondaryUserRole')
      },
    },
  },
  {
    path: '/events',
    name: 'events-index',
    component: () => lazyLoadView(import('@views/events/EventsListView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        checkRole(next, 'events_page', 'secondaryUserRole')
      },
    },
  },
  {
    path: '/events/notifications',
    name: 'event-notifications-index',
    component: () =>
      lazyLoadView(import('@views/events/EventNotificationsListView')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        checkRole(next, 'events_page', 'secondaryUserRole')
      },
    },
  },
  {
    path: '/login',
    redirect: { name: 'landing-page' },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/src/router/views/_shared/NotFoundView'),
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  {
    path: '/flipper',
    meta: {
      beforeResolve() {
        window.location.href = `${process.env.VUE_APP_API_ENDPOINT}/flipper`
      },
    },
  },
  {
    path: '/:catchAll(.*)',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = defineAsyncComponent({
    // the loader function
    loader: () => AsyncView,
    // A component to use while the async component is loading
    loadingComponent: LoadingView,
    // Delay before showing the loading component. Default: 400ms.
    delay: 400,
    // A component to use if the load fails
    errorComponent: TimeoutView,
    // The error component will be displayed if a timeout is
    // provided and exceeded. Default: Infinity.
    timeout: 10000,
  })

  return Promise.resolve(AsyncHandler)
}
